import {Box, styled} from '@mui/material';

const StyledBox = styled(Box)`
	margin-bottom: 50px;
	margin-top: auto;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin-bottom: 0px;
	}
`;

export {StyledBox};
